import React from 'react';
import GlobalDialog from '../../components/@extended/GlobalDialog';
import { CopyTradingTableDto } from './CopyTradingTableSection';
import BulkEditSlaveTable from './components/BulkEditSlaveTable';
import { ReactComponent as EditIcon } from '../../assets/images/icons/edit2.svg';

interface CopierBulkEditDialogProps {
  isOpen: boolean;
  onClose: () => void;
  selectedMaster: CopyTradingTableDto;
  selectedSlaves: CopyTradingTableDto[];
  onSuccess: () => void;
}

const CopierBulkEditDialog = ({
  isOpen,
  onClose,
  selectedMaster,
  selectedSlaves,
  onSuccess
}: CopierBulkEditDialogProps) => {
  return (
    <GlobalDialog
      open={isOpen}
      onClose={onClose}
      title="Bulk Edit Slaves"
      subtitle={`Editing ${selectedSlaves.length} slave${selectedSlaves.length > 1 ? 's' : ''} on ${selectedMaster.accountName}`}
      icon={EditIcon}
      maxWidth="xl"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          maxWidth: '95vw',
          width: '95vw'
        }
      }}
      hideHeader
    >
      <BulkEditSlaveTable
        handleClose={onClose}
        handleSuccess={onSuccess}
        selectedMaster={selectedMaster}
        selectedSlaves={selectedSlaves}
      />
    </GlobalDialog>
  );
};

export default CopierBulkEditDialog;
